import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import DateRange from "@material-ui/icons/DateRange";
import CameraEnhance from "@material-ui/icons/CameraEnhance";
import NotificationImportant from "@material-ui/icons/NotificationImportant";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/westmorland-lodge-44/views/landingPageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>What's happening at the lodge?</h2>
            <h5 className={classes.description}>
              Come visit our calendar to see what we're up to!
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Calendar"
                description="Keep tabs on upcoming events with our community calendar."
                icon={DateRange}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Media"
                description="Take a look at photos from our past events!"
                icon={CameraEnhance}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Newsletter"
                description="Sign up for our newsletter to receive news and event information via email."
                icon={NotificationImportant}
                iconColor="primary"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ProductSection.jsx